export class TraceNode implements ITraceNode {
    
    public DisplayName = '';
    public Name = '';
    public DataKeyString = '';
    public Level = '';
    public Selected = false;
    public Nodes: Array<ITraceNode> = [];
    
    constructor(node: ITraceNode) {
        this._processData(node);        
    }

    public replicateState(state: string) {
        if (this.hasChildren()) {
            this.Nodes.forEach((child: ITraceNode) => {
                child.Level = state;
                child.replicateState(state);
            })
        }
    }

    public toJson() {
        return {
            Level: this.Level.replace(/\b\w/g, l => l.toUpperCase()),
            DisplayName: this.Name,
            DataKeyString: this.DataKeyString,
            Nodes: this.hasChildren() ? this.Nodes.map((node: ITraceNode) => {
                return node.toJson()
            }) : undefined
        }
    }

    private hasChildren(): boolean {
        return this.Nodes.length > 0;
    }
    
    private _processData(node: ITraceNode) {
        this.DataKeyString = node.DataKeyString;
        this.Name = node.DisplayName;
        this.DisplayName = node.DisplayName.replace(/^.*\-(?=[^-]*$)/, '');        
        this.Level = node.Level;

        if (Array.isArray(node.Nodes)) {
            node.Nodes.forEach((child: ITraceNode) => {
                this.Nodes.push(new TraceNode(child));
            });                        
        }
    }
}